<template>
    <el-dialog
        v-if="visible"
        :visible="visible"
        :show-close="false"
        width="660px"
        :close-on-click-modal="false"
    >
        <div class="dialog">
            <dialogHeader
                :title="actionType == 'add' ? '新增配置' : '编辑配置'"
                @closeDialog="onLeave"
            ></dialogHeader>
            <div class="dialogList">
                <el-form
                    :rules="rules"
                    ref="addObj"
                    :model="addObj"
                    label-width="120px"
                >
                    <el-form-item
                        label="供应商"
                        prop="memberid"
                        v-if="actionType == 'add'"
                    >
                        <el-select
                            v-model="memberType"
                            placeholder="请选择"
                            style="width: 120px"
                            size="small"
                        >
                            <el-option
                                v-for="item in memberTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            size="small"
                            v-model="addObj.memberid"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="`请输入${memberTypeList[memberType].label}搜索用户`"
                            :remote-method="remoteMethod"
                            :loading="selectLoading"
                            style="width: 280px"
                        >
                            <el-option
                                v-for="item in memberList"
                                :key="item.id"
                                :label="item.dname"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="父商户编号：" prop="parent_merchant_no">
                        <el-input
                            v-model.trim="addObj.parent_merchant_no"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="商户号：" prop="merchant_no">
                        <el-input
                            v-model.trim="addObj.merchant_no"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="商户简称：" prop="short_name">
                        <el-input
                            v-model.trim="addObj.short_name"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="微信公众号/小程序APPID：" prop="sub_wx_appid">
                        <el-input
                            v-model.trim="addObj.sub_wx_appid"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="是否分账：" prop="split_type">
                        <el-radio-group v-model="addObj.split_type">
                            <el-radio label="0">不分账</el-radio>
                            <el-radio label="1">分账</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
                flex="cross:center main:right"
            >
                <el-button size="small" @click="onLeave">取 消</el-button>
                <el-button
                    size="small"
                    type="primary"
                    :loading="addLoading"
                    @click="onSumbit('addObj')"
                >
                    确 定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { editMerchantYeePay, addMerchantYeePay } from "@/api/config";
import { queryMemberByCondition } from "@/api/admin";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        actionType: {
            type: String,
            default: "add",
        },
        config: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            rules: {
                parent_merchant_no: [
                    {
                        required: true,
                        message: "父商户编号不能为空",
                        trigger: "blur",
                    },
                ],
                merchant_no: [
                    {
                        required: true,
                        message: "商户号不能为空",
                        trigger: "blur",
                    },
                ],
                sub_wx_appid: [
                    {
                        required: true,
                        message: "微信公众号/小程序APPID不能为空",
                        trigger: "blur",
                    },
                ],
                split_type: [
                    {
                        required: true,
                        message: "是否分账不能为空",
                        trigger: "blur",
                    },
                ],
            },
            addObj: {
                id: "",
                memberid: "", // 票付通平台的用户ID
                parent_merchant_no: "", // 父商户编号
                merchant_no: "", // 商户号，入网返回
                short_name: "", // 商户简称
                sub_wx_appid: "", // 微信小程序appid，入网返回
                split_type: "0", // 是否分账，默认不分账
            },
            selectLoading: false,
            memberTypeList: [
                {
                    value: 0,
                    label: "账号",
                },
                {
                    value: 1,
                    label: "手机号",
                },
                {
                    value: 2,
                    label: "名称",
                },
            ],
            memberType: 0, // 用户搜索类型
            memberList: [], // 用户列表
            addLoading: false,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                if (this.actionType === "edit" && this.config) {// 克隆 config 数据到 addObj
                    this.addObj = Object.assign({}, this.config);
                }
            } else {
                this.addObj = this.$options.data().addObj; // 重置数据
            }
        },
    },
    methods: {
        async remoteMethod(val) {
            let pType = {
                0: "account",
                1: "mobile",
                2: "dname",
            };
            let params = {
                page_size: 100,
                [pType[this.memberType]]: val,
            };
            this.selectLoading = true;
            const res = await queryMemberByCondition(params);
            this.selectLoading = false;
            if (res.code != 200) return;
            this.memberList = res.data;
        },
        onLeave() {
            this.$emit("update:visible", false);
        },
        onSumbit(formName) {
            if (this.addLoading) return;
            let { actionType } = this;
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let func = addMerchantYeePay;
                    let params = {
                        ...this.addObj,
                    };
                    if (actionType == "edit") {
                        func = editMerchantYeePay;
                    }
                    this.addLoading = true;
                    const res = await func(params);
                    this.addLoading = false;
                    if (res.code != 200) return this.$message.error(res.msg || "操作失败");
                    this.$message.success(res.msg || "操作成功");
                    this.onLeave();
                    this.$emit("refresh");
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style></style>
